// import { motion } from "framer-motion";
// import { FiAward, FiUserCheck, FiSun, FiTarget } from "react-icons/fi";

// const highlights = [
//   {
//     icon: FiAward,
//     title: "Oldest Apex Chamber",
//     desc: "Dedicated to connecting industries, government & global partners since 1921.",
//   },
//   {
//     icon: FiUserCheck,
//     title: "Industry–Govt Conduit",
//     desc: "A vital bridge between Corporate India and policymakers at every level.",
//   },
//   {
//     icon: FiTarget,
//     title: "Actionable Advocacy",
//     desc: "Policy recommendations that strengthen the Indian economy at scale.",
//   },
//   {
//     icon: FiSun,
//     title: "Knowledge Chamber",
//     desc: "Empowering stakeholders with research, insights & growth catalysts.",
//   },
// ];

// export default function AboutSection() {
//   return (
//     <section id="about" className="relative bg-white py-20 md:py-4">
//       <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
//         <div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-16">
//           {/* Image side */}
//           <motion.div
//             initial={{ opacity: 0, x: -40 }}
//             whileInView={{ opacity: 1, x: 0 }}
//             viewport={{ once: true, margin: "-80px" }}
//             transition={{ duration: 0.7 }}
//             className="relative"
//           >
//             <div className="img-reveal relative overflow-hidden rounded-3xl shadow-2xl shadow-black/10">
//               <img
//                 src="https://images.pexels.com/photos/7581114/pexels-photo-7581114.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=800&w=1000"
//                 alt="ASSOCHAM collaborative business meeting"
//                 className="h-[360px] w-full object-cover sm:h-[440px]"
//               />
//               <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent" />
//               <div className="absolute bottom-6 left-6 right-6">
//                 <p className="text-sm font-semibold text-white">
//                   Industry Voice of India
//                 </p>
//                 <p className="text-xs text-white/80">
//                   Bridging business & policy for a century
//                 </p>
//               </div>
//             </div>

//             {/* Floating badge */}
//             <motion.div
//               initial={{ opacity: 0, scale: 0.8 }}
//               whileInView={{ opacity: 1, scale: 1 }}
//               viewport={{ once: true }}
//               transition={{ delay: 0.4 }}
//               className="absolute -bottom-6 -right-4 rounded-2xl bg-[#DA2128] px-5 py-4 shadow-xl shadow-[#DA2128]/40 sm:-right-6"
//             >
//               <p className="text-3xl font-bold text-white">100+</p>
//               <p className="text-xs font-medium text-white/90">Years of Legacy</p>
//             </motion.div>

//             {/* Decorative square */}
//             <div className="absolute -left-4 -top-4 -z-10 h-full w-full rounded-3xl border-2 border-[#DA2128]/15" />
//           </motion.div>

//           {/* Content side */}
//           <motion.div
//             initial={{ opacity: 0, x: 40 }}
//             whileInView={{ opacity: 1, x: 0 }}
//             viewport={{ once: true, margin: "-80px" }}
//             transition={{ duration: 0.7 }}
//           >
//             {/* <span className="mb-3 inline-block text-xs font-bold tracking-[0.2em] text-[#DA2128] uppercase">
//               Who We Are
//             </span> */}
//             <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
//               About Us
//             </h2>
//             <div className="mt-4 accent-bar" />

//             <div className="mt-6 space-y-4 text-sm leading-relaxed text-gray-600 sm:text-base">
//               <p>
//                 The Associated Chambers of Commerce and Industry of India
//                 (ASSOCHAM) is the country's oldest apex chamber, dedicated to
//                 connecting industries, government, and global partners since
//                 1921. Over the years, ASSOCHAM has transformed from a provincial
//                 chamber into India's Apex Chamber of Commerce, serving as a
//                 vital conduit between industry and the Government.
//               </p>
//               <p>
//                 ASSOCHAM advocates actionable policy recommendations to
//                 strengthen the Indian economy by leveraging its extensive
//                 membership base of over{" "}
//                 <strong className="text-gray-900">450,000 companies</strong>,
//                 comprising large corporates and MSMEs. With more than{" "}
//                 <strong className="text-gray-900">250 associations</strong> in
//                 India and overseas, and{" "}
//                 <strong className="text-gray-900">70 National and State Councils</strong>,
//                 the Chamber effectively represents diverse segments of the Indian
//                 and global industrial landscape.
//               </p>
//               <p>
//                 ASSOCHAM works collaboratively with the Government, regulators,
//                 and national and international think tanks to contribute to the
//                 public policy process. Through research, industry insights, and
//                 policy advocacy, ASSOCHAM aims to empower stakeholders across
//                 the Indian economy with knowledge that serves as a catalyst for
//                 growth in an increasingly dynamic global environment.
//               </p>
//             </div>
//           </motion.div>
//         </div>

//         {/* Highlight cards */}
//         <div className="mt-20 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
//           {highlights.map((item, i) => (
//             <motion.div
//               key={item.title}
//               initial={{ opacity: 0, y: 30 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               viewport={{ once: true }}
//               transition={{ delay: i * 0.1, duration: 0.5 }}
//               className="card-glow group rounded-2xl border border-gray-100 bg-[#FAF7F2] p-6"
//             >
//               <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-xl bg-[#DA2128]/10 text-[#DA2128] transition-all group-hover:bg-[#DA2128] group-hover:text-white">
//                 <item.icon size={22} />
//               </div>
//               <h3 className="mb-2 text-base font-bold text-gray-900">
//                 {item.title}
//               </h3>
//               <p className="text-sm leading-relaxed text-gray-600">{item.desc}</p>
//             </motion.div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// }




// new new code 




import { motion } from "framer-motion";
import { FiAward, FiUserCheck, FiSun, FiTarget, FiArrowDown } from "react-icons/fi";
import { useState } from "react";
import Foundation_video from "../assets/ASSOCHAM_FOUNDATION.mp4"

const highlights = [
  {
    icon: FiAward,
    title: "Oldest Apex Chamber",
    desc: "Dedicated to connecting industries, government & global partners since 1921.",
  },
  {
    icon: FiUserCheck,
    title: "Industry–Govt Conduit",
    desc: "A vital bridge between Corporate India and policymakers at every level.",
  },
  {
    icon: FiTarget,
    title: "Actionable Advocacy",
    desc: "Policy recommendations that strengthen the Indian economy at scale.",
  },
  {
    icon: FiSun,
    title: "Knowledge Chamber",
    desc: "Empowering stakeholders with research, insights & growth catalysts.",
  },
];

/* ---------------- BREADCRUMB ---------------- */
function Breadcrumb() {
  return (
    <nav
      aria-label="Breadcrumb"
      className="breadcrumb-in absolute left-4 top-4 z-20 sm:left-8 sm:top-6"
    >
      <ol className="flex items-center gap-2 rounded-full border border-black/10 bg-white/70 px-4 py-2 text-xs font-bold uppercase tracking-wide text-[#141419] shadow-lg shadow-black/5 backdrop-blur-md sm:text-sm">
        <li>
          <a
            href="#top"
            className="inline-flex items-center gap-1.5 transition-colors duration-300 hover:text-[#DA2128]"
          >
            <svg
              viewBox="0 0 24 24"
              className="h-4 w-4"
              fill="none"
              stroke="currentColor"
              strokeWidth={2.2}
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M3 10.5 12 3l9 7.5" />
              <path d="M5 10v10h14V10" />
              <path d="M9 20v-6h6v6" />
            </svg>
            Home
          </a>
        </li>
        <li className="text-black/30">&rsaquo;</li>
        <li>
          <a href="#about" className="transition-colors duration-300 hover:text-[#DA2128]">
            About
          </a>
        </li>
        <li className="text-black/30">&rsaquo;</li>
        <li className="rounded-full bg-[#DA2128] px-3 py-1 text-white shadow-sm">About Us</li>
      </ol>
    </nav>
  );
}


export default function AboutSection() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <section id="about" className="relative bg-white py-20 md:py-4">

      <header id="top" className="relative overflow-hidden bg-[#FAF7F2]">
      {/* backdrop decorations */}
      <div className="hero-grid absolute inset-0" />
      <div className="pointer-events-none absolute -top-32 left-1/2 h-[360px] w-[680px] -translate-x-1/2 rounded-full bg-[#DA2128]/10 blur-[130px]" />
      <div className="pointer-events-none absolute -bottom-40 -right-24 h-[320px] w-[320px] rounded-full bg-[#DA2128]/[0.07] blur-[110px]" />

      {/* vertical tag */}
      {/* <span
        aria-hidden
        className="absolute bottom-24 right-6 hidden rotate-180 text-[10px] font-bold uppercase tracking-[0.5em] text-black/30 [writing-mode:vertical-rl] xl:block"
      >
        Est. 1921 — Apex Chamber of India
      </span> */}

      <Breadcrumb />

      <div className="relative mx-auto max-w-7xl px-4 pb-16 pt-28 sm:px-6 sm:pt-32 lg:px-8 lg:pb-20">
        <motion.p
          initial={{ opacity: 0, y: 18 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.15 }}
          className="mb-4 inline-flex items-center gap-3 text-[11px] font-bold uppercase tracking-[0.35em] text-[#DA2128] sm:text-xs"
        >
          <span className="h-px w-10 bg-[#DA2128]" />
          The Associated Chambers of Commerce &amp; Industry of India
        </motion.p>

        <motion.h1
          initial={{ opacity: 0, y: 26 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.25 }}
          className="max-w-3xl font-serif text-5xl font-bold leading-[1.05] text-[#141419] sm:text-6xl lg:text-7xl"
        >
          About <span className="font-serif text-[#DA2128]">Us</span>
        </motion.h1>

      </div>

      {/* bottom shimmer line + scroll cue */}
      <div className="relative">
        <div className="shimmer-line h-px w-full" />
        <motion.a
          href="#about"
          aria-label="Scroll to about section"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1 }}
          className="relative -top-4 left-1/2 flex h-9 w-9 -translate-x-1/2 items-center justify-center rounded-full border border-black/10 bg-white text-gray-500 shadow-sm transition-colors hover:border-[#DA2128] hover:text-[#DA2128]"
        >
          <FiArrowDown className="animate-bounce" size={15} />
        </motion.a>
      </div>
    </header>

      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-16">
          {/* Video side */}
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7 }}
            className="relative"
          >
            <div className="img-reveal relative overflow-hidden rounded-3xl shadow-2xl shadow-black/10 cursor-pointer group"
                 onClick={() => setIsModalOpen(true)}>

              <video
  autoPlay
  muted
  loop
  playsInline
  className="h-[360px] w-full object-cover sm:h-[440px]"
>
  <source src={Foundation_video} type="video/mp4" />
  Your browser does not support the video tag.
</video>

              {/* Play icon overlay */}
              <div className="absolute inset-0 flex items-center justify-center transition-all duration-300">
                {/* <div className="h-16 w-16 rounded-full border-4 border-white/90 flex items-center justify-center backdrop-blur-sm">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-white ml-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 4.01V8" />
                  </svg>
                </div> */}
              </div>

              <div className="absolute inset-0" />
              {/* <div className="absolute bottom-6 left-6 right-6">
                <p className="text-sm font-semibold text-white">
                  Industry Voice of India
                </p>
                <p className="text-xs text-white/80">
                  Bridging business & policy for a century
                </p>
              </div> */}
            </div>

            {/* Floating badge */}
            <motion.div
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ delay: 0.4 }}
              className="absolute -bottom-6 -right-4 rounded-2xl bg-[#DA2128] px-5 py-4 shadow-xl shadow-[#DA2128]/40 sm:-right-6"
            >
              <p className="text-3xl font-bold text-white">100+</p>
              <p className="text-xs font-medium text-white/90">Years of Legacy</p>
            </motion.div>

            {/* Decorative square */}
            <div className="absolute -left-4 -top-4 -z-10 h-full w-full rounded-3xl border-2 border-[#DA2128]/15" />
          </motion.div>

          {/* Content side */}
          <motion.div
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7 }}
          >
           <h2 className="pt-4 text-[15px] font-bold tracking-tight text-[#da2128] sm:text-[15px]">
  About ASSOCHAM
</h2>
            <div className="mt-4 accent-bar" />

            <div className="mt-[-0.5rem] space-y-4 text-sm leading-relaxed text-gray-600 sm:text-base text-justify">
              <p>
                The Associated Chambers of Commerce and Industry of India
                (ASSOCHAM) is the country's oldest apex chamber, dedicated to
                connecting industries, government, and global partners since
                1921. Over the years, ASSOCHAM has transformed from a provincial
                chamber into India's Apex Chamber of Commerce, serving as a
                vital conduit between industry and the Government.
              </p>
              <p>
                ASSOCHAM advocates actionable policy recommendations to
                strengthen the Indian economy by leveraging its extensive
                membership base of over{" "}
                <strong className="text-gray-900">450,000 companies</strong>,
                comprising large corporates and MSMEs. With more than{" "}
                <strong className="text-gray-900">250 associations</strong> in
                India and overseas, and{" "}
                <strong className="text-gray-900">70 National and State Councils</strong>,
                the Chamber effectively represents diverse segments of the Indian
                and global industrial landscape.
              </p>
              <p>
                ASSOCHAM works collaboratively with the Government, regulators,
                and national and international think tanks to contribute to the
                public policy process. Through research, industry insights, and
                policy advocacy, ASSOCHAM aims to empower stakeholders across
                the Indian economy with knowledge that serves as a catalyst for
                growth in an increasingly dynamic global environment.
              </p>
            </div>
          </motion.div>
        </div>

        {/* Highlight cards */}
        <div className="mt-20 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {highlights.map((item, i) => (
            <motion.div
              key={item.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1, duration: 0.5 }}
              className="card-glow group rounded-2xl border border-gray-100 bg-[#FAF7F2] p-6"
            >
              <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-xl bg-[#DA2128]/10 text-[#DA2128] transition-all group-hover:bg-[#DA2128] group-hover:text-white">
                <item.icon size={22} />
              </div>
              <h3 className="mb-2 text-base font-bold text-gray-900">
                {item.title}
              </h3>
              <p className="text-sm leading-relaxed text-gray-600">{item.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>

      {/* Video Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 p-4">
          <div className="relative w-full max-w-5xl">
            <button
              onClick={() => setIsModalOpen(false)}
              className="absolute -top-12 right-0 text-white text-4xl hover:text-gray-300 transition-colors"
            >
              ×
            </button>
            
            <div className="aspect-video bg-black rounded-2xl overflow-hidden shadow-2xl">
              <video
                src="/assets/Foundation.mp4"
                controls
                autoPlay
                className="w-full h-full"
              />
            </div>
          </div>
        </div>
      )}
    </section>
  );
}